import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsSeparatedInputType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('is_separated_input_type')(jsonQuery) === true,
);
